import api, { buildService } from './index'

export default {
  ...buildService('distributors'),
  getCurrent: () => api.get('distributors/current')
}
